export default __webpack_public_path__ + "static/media/yahoo-icon.77945e40.jpg";